<template>
    <div v-if="isModalOpen" class="modal-overlay">
        <form action="" class="modal" @submit.prevent="submitForm" v-click-outside="handleClickOutside">
            <div class="modal-content">
                <p class="modal-content-title">برای دریافت مشاوره رایگان اطلاعات خود را وارد کنید.</p>
                <div class="contact-fields">
                    <label for="user-name">نام و نام خانوادگی:</label>
                    <input v-model="name" :disabled="isFormDisabled" name="user-name" type="text" id="user-name">
                    <label for="mobile-number"> شماره تماس:</label>
                    <input v-model="mobile" :disabled="isFormDisabled" name="mobile-number" type="text" id="mobile-number">
                </div>
                <p v-if="invalid" class="form-invalid">{{ invalidMessage }}</p>
                <button type="submit" class="btn btn--secondary">ثبت</button>
            </div>
            <FormMessage :isFormSubmitted="isFormSubmitted"></FormMessage>
        </form>
    </div>
</template>

<script>
import FormMessage from './FormMessage.vue';
import axios from 'axios';
import { ref, getCurrentInstance } from 'vue';
export default {
    name: "ModalBox",
    components: {
        FormMessage,
    },
    props: {
        isModalOpen: {
            type: Boolean,
            required: true,
        },
    },
    setup(props, { emit }) {
        const toEnglishDigits = (str) => str.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
        const name = ref('');
        const mobile = ref('');
        const invalid = ref(false);
        const invalidMessage = ref('');
        const isFormDisabled = ref(false);

        const { proxy } = getCurrentInstance();

        const isFormSubmitted = ref(false);

        // formMessage
        const formMessage = ref('');
        const getFormMessage = async (name, mobile) => {
            try {
                const response = await axios({
                    method: 'POST',
                    url: `${process.env.VUE_APP_ONCLICK_PANEL_DOMAIN}/advertiser/save`,
                    data: {
                        name: name,
                        mobile: mobile
                    },
                });
                formMessage.value = response.data.m ? response.data.m : response.data.r;
                isFormSubmitted.value = true;
            } catch (err) {
                console.error('خطا در دریافت اطلاعات:', err);
                formMessage.value = "مجددا تلاش کنید.";
                isFormSubmitted.value = false;
            }
        };

        const submitForm = async () => {
            mobile.value = toEnglishDigits(mobile.value);
            const phoneRegex = /^09\d{9}$/;

            if (!mobile.value.trim()) {
                invalid.value = true;
                invalidMessage.value = 'لطفاً همه فیلدها را پر کنید.';
            } else if (!phoneRegex.test(mobile.value)) {
                invalid.value = true;
                invalidMessage.value = 'شماره تلفن معتبر نیست.';
            } else {
                invalid.value = false;
                isFormDisabled.value = true;
                await getFormMessage(name.value, mobile.value);
                proxy.$eventBus.emit('form-message', formMessage.value);
                name.value = '';
                mobile.value = '';
                setTimeout(() => {
                  emit('close');
                  isFormDisabled.value = false;
                }, 2000);
            }
        };

        const handleClickOutside = () => {
            emit('close');
        };

        return {
            name,
            mobile,
            invalid,
            submitForm,
            invalidMessage,
            formMessage,
            isFormDisabled,
            handleClickOutside,
            isFormSubmitted,
        }

    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.41);
    z-index: 999;
}

.modal {
    border-radius: 20px;
    background-color: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(128px);
    box-shadow: 0 2px 10px var(--shadow-light);
    padding: 39px 28px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.modal-content {
    gap: 30px;
}

.modal-content,
.contact-fields {
    display: flex;
    flex-direction: column;
}

.modal-content-title {
    font-size: 24px;
    text-align: center;
}

.modal-content input {
    border-radius: 5px;
    border: none;
    padding: 15px 12px;
    font-size: 14px;
}

.modal-content input:focus {
    outline-color: var(--main-pink);
    background-color: #ececec;
}

.contact-fields {
    gap: 15px;
}

.form-invalid {
    color: #b90000;
    font-size: 20px;
}

@media screen and (max-width: 1024px) {
    .form-invalid {
        font-size: 16px;
    }
}

@media screen and (max-width: 768px) {
    .modal {
        width: 60%;
        padding: 25px 20px;
    }

    .modal-content {
        gap: 20px;
    }

    .modal-content-title {
        font-size: 18px;
    }

    .modal-content label {
        font-size: 14px;
    }

    .modal-content input {
        padding-block: 12px;
    }

}

@media screen and (max-width: 576px) {
    .modal {
        width: 89%;
    }
}
</style>